import { styled } from "styled-components";

import { CarouselSlider, ListItemBox } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { RelatedTopicCard } from "domains/topic/components/RelatedTopicCard";
import { TopicDetailSection } from "domains/topicDetail/components/TopicDetailSection";
import { getTmSelectedInnerNode } from "domains/transformationMap/selectors";
import { createTopicSelector } from "entities/topics/selectors";

const StyledCarousel = styled(CarouselSlider)`
  padding: 0;
`;

type TopicKeyIssueSectionProps = { scrollToTop: () => void; selectedSectionId?: string; topicId: string };

export const TopicKeyIssueSection = ({ topicId, selectedSectionId, scrollToTop }: TopicKeyIssueSectionProps) => {
  const translate = useTranslate();
  const topic = useSelector(createTopicSelector(topicId));
  const keyIssue = useSelector(getTmSelectedInnerNode);

  const list = keyIssue ? keyIssue.topics : topic?.dimensions;

  return (
    <TopicDetailSection
      display
      isHidden={!!selectedSectionId}
      isHorizontal
      title={translate(keyIssue ? "app.topic.related_topics" : "app.topic.key_issues")}
      topicId={topicId}
    >
      <StyledCarousel>
        {list?.map((issue) => (
          <ListItemBox key={issue.id}>
            <RelatedTopicCard topic={issue} scrollToTop={scrollToTop} isKeyIssue={!!keyIssue} />
          </ListItemBox>
        ))}
      </StyledCarousel>
    </TopicDetailSection>
  );
};
